export default __webpack_public_path__ + "static/media/bg_sel.1675addb.png";